<!-- one line (#173): zoek and the filters, the bulk actions, the pager and
     new; the filters that are on drop below it. Always there, also when the
     result is empty, since that is when the filters need changing. -->
<div class="top-controls">
    <div class="top-bar">
        <header-filters></header-filters>

        <single-choice
            class="bulk"
            [topic]="'multi-action'"
            [ticketId]="1"
            [editMode]="true"
            [locked]="!(hasSelection | async)"
            [completedUrl]="actionUrlObserver"
            [choiceObserver]="actionIdObserver"
            [icon]="'checklist'"
            (choiceEvent)="relaySingleChoice($event)"
            [labelOnDemand]="actionLabelerByService"
            ></single-choice>

        <div class="pager" *ngIf="totalPages > 1">
            <button class="step" (click)="goToPage(0)" [disabled]="currentPage === 0"
                    [attr.aria-label]="'pagination.first' | translate">
                <span class="material-icons-outlined">first_page</span>
            </button>
            <button class="step" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0"
                    [attr.aria-label]="'pagination.previous' | translate">
                <span class="material-icons-outlined">chevron_left</span>
            </button>
            <span class="current">{{ currentPage + 1 }}</span>
            <span class="total">{{ 'pagination.of' | translate }} {{ totalPages }}</span>
            <button class="step" (click)="goToPage(currentPage + 1)" [disabled]="currentPage >= totalPages - 1"
                    [attr.aria-label]="'pagination.next' | translate">
                <span class="material-icons-outlined">chevron_right</span>
            </button>
            <button class="step" (click)="goToPage(totalPages - 1)" [disabled]="currentPage >= totalPages - 1"
                    [attr.aria-label]="'pagination.last' | translate">
                <span class="material-icons-outlined">last_page</span>
            </button>
        </div>

        <button class="plus" (click)="createTicket()">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
    </div>
</div>
<div class="table-container" [ngClass]="{ 'half-screen': selectedTicket }">
    <div class="table-scroll">
        <table>
            <thead></thead>
            <tbody>
                <tr
                    *ngFor="let ticket of paginatedTickets"
                    (click)="select(ticket)"
                    [class.selected]="ticket === selectedTicket"
                    >
                    <td>
                        <div class="all">
                            <div>
                                <span class="ticket-date">{{ dateFormatted(ticket) }}</span>
                            </div>
                            <div class="top-row">
                                <!-- a finger-sized target around the box (#173); a click on it
                                     checks the box and does not open the ticket -->
                                <label class="check-target" (click)="$event.stopPropagation()">
                                    <input
                                        class="check"
                                        type="checkbox"
                                        [checked]="isSelected(ticket)"
                                        (click)="toggleSelect(ticket); $event.stopPropagation()"
                                        />
                                </label>

                                <span class="ticket-title">{{ ticket.title }}</span>
                                <span
                                    class="recurring-badge"
                                    *ngIf="isRecurring(ticket)"
                                    [title]="'recurrence.details.badge' | translate">
                                    <span class="material-icons-outlined">repeat</span>
                                </span>
                            </div>
                            <div class="bottom-row">
                                <dependent-choice
                                    *ngIf="isValidChoice(ticket.statusId)"                                    class="sts"
                                    [topic]="'status'"
                                    [reduced]="TRUE"
                                    [isTicketContext]="TRUE"
                                    [showLabel]="TRUE"
                                    [selectedId]="ticket.statusId"
                                    [labelOnDemand]="statusLabelerByService"
                                    ></dependent-choice>
                                <dependent-choice
                                    *ngIf="isValidChoice(ticket.departmentId)"                                    class="dep"
                                    [topic]="'departments'"
                                    [reduced]="TRUE"
                                    [isTicketContext]="TRUE"
                                    [showLabel]="TRUE"
                                    [selectedId]="ticket.departmentId"
                                    [choiceObserver]="departmentIdObserver"
                                    [labelOnDemand]="departmentLabelerByService"
                                    ></dependent-choice>
                                <dependent-choice
                                    *ngIf="isValidChoice(ticket.branchId)"
                                    class="dc"
                                    [topic]="'branches'"
                                    [reduced]="TRUE"
                                    [isTicketContext]="TRUE"
                                    [showLabel]="TRUE"
                                    [selectedId]="ticket.branchId"
                                    [labelOnDemand]="branchLabelerByService"
                                    ></dependent-choice>
                                <div class="space">
                                    <dependent-choice
                                        *ngIf="isValidChoice(ticket.priorityId)"
                                        class="prio"
                                        [topic]="'priority'"
                                        [reduced]="TRUE"
                                        [isTicketContext]="TRUE"
                                        [showLabel]="TRUE"
                                        [selectedId]="ticket.priorityId"
                                        [labelOnDemand]="priorityLabelerByService"
                                        ></dependent-choice>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <empty-details *ngIf="isEmptyResult"
                       title="empty.noTicketsFound"
                       hint="empty.adjustFilters"></empty-details>
    </div>
    <div class="pagination-info" *ngIf="paginatedTickets.length > 0">
        <span>{{ 'pagination.page' | translate }} {{ currentPage + 1 }} {{ 'pagination.of' | translate }} {{ totalPages }}</span>
        <span class="row">
            {{ startRow + 1 }} {{ 'pagination.to' | translate }} {{ endRow }} {{ 'pagination.of' | translate }} {{ totalRows }}
        </span>
    </div>
</div>